/**
 * Кастомные SVG-иконки блока «Контроль КП» (замена эмодзи, 17.07.2026).
 * Outline-стиль (heroicons), цвет через currentColor — задаётся className.
 */

function Icon({ className, d }: { className: string; d: string }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d={d} />
    </svg>
  )
}

/** Документ — «КП создано». */
export function IconDocument({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Icon
      className={className}
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  )
}

/** Самолётик — «КП отправлено». */
export function IconSend({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Icon
      className={className}
      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
    />
  )
}

/** Колокольчик — «Следующий контакт» / кнопка «Назначить контакт». */
export function IconBell({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Icon
      className={className}
      d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
    />
  )
}

/** Галочка в круге — заявка закрыта «Счёт». */
export function IconCheckCircle({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Icon
      className={className}
      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  )
}

/** Крестик в круге — заявка закрыта «Отказ». */
export function IconXCircle({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Icon
      className={className}
      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  )
}

/** Коробка-архив — заявка «В архиве». */
export function IconArchive({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <Icon
      className={className}
      d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6.25 3.75h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    />
  )
}

/** Шеврон аккордеона «История касаний» (rotate-90 в раскрытом состоянии). */
export function IconChevron({ className = 'w-3 h-3' }: { className?: string }) {
  return <Icon className={className} d="m9 5 7 7-7 7" />
}
